import { useState, useMemo } from "react";

export const usePaginator = (
  data: { [key: string]: any }[],
  rowsPerPage: number
) => {
  const [currentPage, setCurrentPage] = useState(1);

  const paginatedData = useMemo(() => {
    const startIndex = (currentPage - 1) * rowsPerPage;
    const endIndex = startIndex + rowsPerPage;
    return data.slice(startIndex, endIndex);
  }, [currentPage, data, rowsPerPage]);

  const totalPages = Math.ceil(data.length / rowsPerPage);

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
  };

  return { currentPage, paginatedData, totalPages, handlePageChange };
};
